import { t } from "i18next";
import { Button, Form, Modal } from "react-bootstrap";
import { createSpeciality } from "../../../../services/speciality";
import { Media } from "../../../../interfaces/media";
import { useState } from "react";
import Uploader from "../../../general/uploader";

interface AdminSpecialityNewProps {
    onSave: CallableFunction;
    onClose: CallableFunction;
}

export function AdminSpecialityNew(props: AdminSpecialityNewProps) {
    const [media, setMedia] = useState<Media[]>([]);

    const handleSave = (event: any) => {
        event.preventDefault();

        const body = {
            name: event.target.name.value,
            code: event.target.code.value,
            description: event.target.description.value,
            icon: media.length > 0 ? media[0].id : 0
        }
        createSpeciality(body)
            .then(response => {
                if (response.data.status == 1) {
                    props.onSave(response.data.data);
                } else {
                    alert(response.data.message);
                }
            })
            .catch(error => {
                console.log(error);
            });
    }
    
    const handleClose = () => {
        props.onClose();
    }

    const handleMediaEventUpload = (media: Media[]) => {
        if (media.length > 1) {
            alert(t("single_image_warning"));
        } else {
            const newMedia = media.map((m: Media) => { return m; });
            setMedia(newMedia);
        }
    }
    
    return (
        <Modal className="admin-speciality-new-container" show={ true }
            onHide={ handleClose }> 
            <Modal.Header closeButton>
                <Modal.Title>
                    { t("new_speciality") }
                </Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Form onSubmit={ handleSave }>
                    <div className="fields">
                        <Form.Group className="mb-3" controlId="name">
                            <Form.Label aria-required="true">{ t("Name") }</Form.Label>
                            <Form.Control type="text" name="name" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="code">
                            <Form.Label aria-required="true">{ t("code") }</Form.Label>
                            <Form.Control type="text" name="code" required />
                        </Form.Group>
                        <Form.Group className="mb-3" controlId="description">
                            <Form.Label>{ t("description") }</Form.Label>
                            <Form.Control name="description" as="textarea" />
                        </Form.Group>
                        <Form.Group className="mb-3 media-field" controlId="media">
                            <Uploader title={ t("icon_upload_message") }
                                media={ media } save={ handleMediaEventUpload } />
                        </Form.Group>
                    </div>
                    <div className="actions">
                        <Button type="submit" variant="primary">
                            { t("Save") }
                        </Button>
                        <Button variant="secondary" onClick={ handleClose }>
                            { t("Close") }
                        </Button>
                    </div>
                </Form>
            </Modal.Body>
        </Modal>
    );
}